jQuery(document).ready(function () {
    $(document).on('click', '.dnJs-openWithPrintDialog', function (e) {
        e.preventDefault();

        var url = $(this).attr("href");
        var win = window.open(url, '_blank');

        win.onload = function () {
            win.print();
        };
    });
});